module.exports = __webpack_public_path__ + "static/media/catalogos.656ebc92.svg";